export const DATE_PICKER_TYPE = {
  DAY: 'day',
  MONTH: 'month',
  WEEK: 'week',
}
